export const FEATURE_FLAGS = {
  ENABLE_WALKTHROUGH: false,
  ENABLE_PREFERENCE: true,
  ENABLE_WISHLIST: true,
  ENABLE_CLARITY: false,
  ENABLE_OTHERS: true,
};
